module.exports = __webpack_public_path__ + "static/media/single.854b1794.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/single.png
// module id = 454
// module chunks = 0